<app-vertical-bar-graph
    [selectedColumnIndex]="currentSelectedColumnIndex"
    [graph]="data.graph.isMainGraph ? data.graph.data[0].graph : data.graph.data[indexUnit].graph"
    (onBarSelect)="onSelectGarphValue($event)"
    (onUserBarSelect)="onUserBarSelect($event)"
    [type]="getBarType(data)">
</app-vertical-bar-graph>

<app-battery-graph
    [isMainGraph]="!!data.graph.isMainGraph"
    [columnIndex]="currentSelectedColumnIndex"
    [navState]="navState"
    [batteries]="data.graph.isMainGraph ? data.graph.data[0].battery[currentSelectedColumnIndex] : data.graph.data[indexUnit].battery[currentSelectedColumnIndex]">
</app-battery-graph>
